import React, { useEffect } from 'react';
import Header from "template/header/Header";
import Footer from "template/footer/Footer";
import { Helmet } from 'react-helmet';
import useLang from "hook/useLang";
import { useLocation } from "react-router-dom";
import { removeHeaderFooter } from "../tools/tools";
function Template(_a) {
    var children = _a.children;
    var location = useLocation();
    useEffect(function () {
        if (!location.hash) {
            window.scrollTo({ top: 0 });
        }
    }, [location.key]);
    var lang = useLang();
    var setLangDir = function () {
        var tmp = [];
        if (lang.lang) {
            tmp.push(React.createElement("html", { key: lang.lang.toString(), lang: lang.lang }));
        }
        if (lang.dir) {
            tmp.push(React.createElement("body", { key: lang.dir.toString(), dir: lang.dir }));
        }
        return tmp;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null, setLangDir()),
        React.createElement("div", { className: 'w-full min-h-screen bg-mainBgColor antialiased text-textColor font-dinArabic' },
            React.createElement("header", null,
                React.createElement(Header, null)),
            children,
            !removeHeaderFooter(location.pathname) &&
                React.createElement("footer", null,
                    React.createElement(Footer, null)))));
}
export default Template;
